module.exports = __webpack_public_path__ + "img/button_scale_02.ac649b28.png";